import { createAction } from "@reduxjs/toolkit";

const APPLICATION_ACTION = "application";

export const applicationActions = {
  saveQuoteRequested: createAction<{
    spaceId: string;
    checkIn: string;
    checkOut: string;
  }>(`${APPLICATION_ACTION}/saveQuoteRequested`),
  saveQuoteInProgress: createAction(
    `${APPLICATION_ACTION}/saveQuoteInProgress`,
  ),
  saveQuoteDone: createAction(`${APPLICATION_ACTION}/saveQuoteDone`),
};
